// import { Boot, SlateElement } from '@wangeditor/editor'
import Vue from "vue";
// 生成 html 的函数
function genID(length){
  return Number(Math.random().toString().substr(3,length) + Date.now()).toString(36);
}
function fn(elem, childrenHtml) {
    let str = genID(8)
    console.log(elem, childrenHtml);
    const { a, b, c, d,mpImId,id} = elem;
    const res = `<div onclick="goMessage('${mpImId}','${id}')"  class='classes'>
            <div class="message">
                <div class="top">
                  <div class="title">${a}</div>
                  <div class="content">${b}</div>`+ (c ? `<img id='${str}' src=${c} onerror=messageImg('${str}')>`: `` )+
                `</div>
                <div class="bottom">
                  <div>查看详情</div>
                  <i class="el-icon-arrow-right cubeic-arrow"></i>
                </div>
            </div>
        </div>`;

    return res;
}
// 配置
const conf = {
    type: "message", // 节点 type ，重要！！！
    elemToHtml: fn,
};

export default conf;
